import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, fromEvent, merge } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

export type NetworkStatus = 'online' | 'offline';

@Injectable({
  providedIn: 'root',
})
export class NetworkStatusService {
  private readonly statusSubject = new BehaviorSubject<NetworkStatus>(
    navigator.onLine ? 'online' : 'offline',
  );

  readonly status$: Observable<NetworkStatus> = merge(
    this.statusSubject.asObservable(),
    fromEvent(window, 'online').pipe(map((): NetworkStatus => 'online')),
    fromEvent(window, 'offline').pipe(map((): NetworkStatus => 'offline')),
  ).pipe(distinctUntilChanged());

  readonly isOffline$: Observable<boolean> = this.status$.pipe(
    map((s) => s === 'offline'),
    distinctUntilChanged(),
  );
}
